// Segmented "offen / abgeschlossen" tab control on the transfers index (mobile only; on desktop CSS
// forces both panes visible so this is a no-op there). Bound to [data-transfer-tabs].
// Delegated so it survives #active-list / #completed-list fragment swaps from search/sort/paginate.
up.compiler('[data-transfer-tabs]', (root) => {
  const activateTab = (name) => {
    root.querySelectorAll('.transfers-index__tab').forEach((t) => t.classList.toggle('is-active', t.dataset.tab === name))
    root.querySelectorAll('.transfers-index__pane').forEach((p) => p.classList.toggle('is-active', p.dataset.pane === name))
  }

  up.on(root, 'click', '[data-tab]', (event, el) => {
    event.preventDefault()
    activateTab(el.dataset.tab)
  })
})
